import { SET_MENU_DETAIL } from '../actions/subMenuAction';

export const subMenuInitialState = { isLoading: true };

const subMenuReducer = (state = subMenuInitialState, action) => {
  switch (action.type) {
    case SET_MENU_DETAIL:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    default:
      break;
  }
  return state;
};

export default subMenuReducer;
